import React, { useState } from "react";
import Save from "../../image/Save.png";
import { BiReset } from "react-icons/bi";

export default function GorgeousHoverButton({
  onClick,
}) {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);

  const buttonStyle = {
    position: "relative",
    display: "flex",
    alignItems:"center",
    justifyContent:"center",
    width:"3vw",
    height:"3vw",
    padding: "14px 6px",
    fontSize: ".75vw",
    fontWeight: "700",
    letterSpacing: "1px",
    borderRadius: "1vw",
    marginLeft:"1vw",
    border: "none",
    cursor: "pointer",
    color: hover ? "#fff" : "#e0e0e0",
    background: hover
      ? "linear-gradient(135deg, #441D30, #441D30)"
      : "linear-gradient(135deg, #000000, #000000)",
    boxShadow: active? "inset 0 2px 8px rgba(0,0,0,0.6)"
    : hover
    ? "0 0 25px rgba(255, 99, 71, 0.6), 0 0 60px rgba(255, 195, 113, 0.4)"
    : "0 5px #999",
    transform: active
    ? "translateY(2px) scale(0.97)"
    : hover
    ? "translateY(-4px) scale(1.06)"
    : "translateY(0) scale(1)",
    transition:
      "all 0.45s cubic-bezier(0.25, 1, 0.5, 1), background-position 0.5s",
    overflow: "hidden",
    backgroundSize: "200% 200%",
    backgroundPosition: hover ? "right center" : "left center",
  };

  const shimmerStyle = {
    content: '""',
    position: "absolute",
    top: 0,
    left: hover ? "100%" : "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(120deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0.2) 100%)",
    transform: "skewX(-25deg)",
    transition: "left 0.8s ease-in-out",
    borderRadius: "inherit",
    pointerEvents: "none",
  };

  return (
    <button
      style={buttonStyle}
      onMouseEnter={() => {
        setHover(true)}
      }
      onMouseLeave={() => {
        setHover(false)
        setActive(false);
        } 
      }
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      onClick={onClick}
    >
    <BiReset 
     style={{
        width:"2.5vw",
        height:"2vw",
     }}
    />
      <span
        style={{
          ...shimmerStyle,
          left: hover ? "100%" : "-120%",
        }}
      ></span>
    </button>
  );
}
